/** TR06 copy (one group per control; a ticket edits only its own file). */
export const tr06PtBr = {
  title: 'Transferências entre contas próprias',
  description:
    'As duas pontas de cada transferência: valor, moeda, entidade, data, trânsito e efeito no resultado.',
  reasons: {
    TRANSFER_LEG_MISSING: 'Transferências com uma ponta só',
    TRANSFER_DIRECTION_INVALID: 'Pontas no mesmo sentido',
    TRANSFER_CURRENCY_MISMATCH: 'Pontas em moedas diferentes',
    TRANSFER_CROSS_ENTITY: 'Pontas em entidades diferentes',
    TRANSFER_AMOUNT_MISMATCH: 'Pontas com valores diferentes',
    TRANSFER_DUPLICATE_LEG: 'Ponta usada em mais de uma transferência',
    TRANSFER_NOT_POSTED: 'Transferências sem lançamento efetivo',
    TRANSFER_POSTING_FAILED: 'Transferências com lançamento recusado',
    TRANSFER_DUPLICATE_EFFECT: 'Transferências lançadas em duplicidade',
    TRANSFER_UNEXPECTED_PNL: 'Transferências com efeito inesperado no resultado',
    TRANSFER_IN_TRANSIT_AGED: 'Em trânsito além da data esperada',
    TRANSFER_TRANSIT_NOT_POSTED: 'Em trânsito sem lançamento na conta de trânsito',
    TRANSFER_TRANSIT_POSTING_FAILED: 'Em trânsito com lançamento recusado',
  },
  observations: {
    TR06_IN_TRANSIT_WITHIN_WINDOW: 'Em trânsito dentro do prazo esperado: {{count}}',
    TR06_CROSS_PERIOD_TRANSFERS: 'Transferências com pontas em meses diferentes: {{count}}',
    TR06_RESTRICTED_ACCOUNT_FINDINGS: 'Pendências em contas com acesso restrito: {{count}}',
  },
};

export const tr06En: typeof tr06PtBr = {
  title: 'Transfers between own accounts',
  description:
    'Both legs of every transfer: amount, currency, entity, date, transit and effect on profit or loss.',
  reasons: {
    TRANSFER_LEG_MISSING: 'Transfers with a single leg',
    TRANSFER_DIRECTION_INVALID: 'Legs in the same direction',
    TRANSFER_CURRENCY_MISMATCH: 'Legs in different currencies',
    TRANSFER_CROSS_ENTITY: 'Legs in different entities',
    TRANSFER_AMOUNT_MISMATCH: 'Legs with different amounts',
    TRANSFER_DUPLICATE_LEG: 'Leg used in more than one transfer',
    TRANSFER_NOT_POSTED: 'Transfers with no effective posting',
    TRANSFER_POSTING_FAILED: 'Transfers with a refused posting',
    TRANSFER_DUPLICATE_EFFECT: 'Transfers posted twice',
    TRANSFER_UNEXPECTED_PNL: 'Transfers with an unexpected profit or loss effect',
    TRANSFER_IN_TRANSIT_AGED: 'In transit past the expected date',
    TRANSFER_TRANSIT_NOT_POSTED: 'In transit with no posting to the transit account',
    TRANSFER_TRANSIT_POSTING_FAILED: 'In transit with a refused posting',
  },
  observations: {
    TR06_IN_TRANSIT_WITHIN_WINDOW: 'In transit within the expected window: {{count}}',
    TR06_CROSS_PERIOD_TRANSFERS: 'Transfers with legs in different months: {{count}}',
    TR06_RESTRICTED_ACCOUNT_FINDINGS: 'Open items on restricted-access accounts: {{count}}',
  },
};
